import { SnackbarMessage } from 'notistack';
import { forwardRef } from 'react';

import SuccessAlert from '../../Alert/SuccessAlert/SuccessAlert';

interface Props {
  message: SnackbarMessage;
}

const SuccessSnackbar = forwardRef<HTMLDivElement, Props>(({ message }, ref) => (
  <div ref={ref}>
    <SuccessAlert>{message}</SuccessAlert>
  </div>
));

export default SuccessSnackbar;
